import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {Poi} from '../../../shared/models/poi';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {map} from 'rxjs/operators';

@Injectable()
export class PoiService {

  private _pois: BehaviorSubject<Poi[]>;

  constructor(
    private http: HttpClient
  ) {
    this._pois = new BehaviorSubject<Poi[]>(null);
  }

  getPois(customerId: number): Observable<Poi[]> {
    const url = `/webofficerpc/rest-endpoint/FeesOffice/poi?customerId=${customerId}`;

    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.http.get<Poi[]>(url, {headers})
      .pipe(
        map((pois: Poi[]) => {
          this._pois.next(pois);

          return pois;
        })
      );
  }

}
